module.exports = {"REGION":"us-west-2","COGNITO":{"IDENTITY_POOL_ID":"us-west-2:ea56fa54-3a6d-4f20-9eca-b890a0402d67"},"LAMBDA":{"FUNCTION_NAME":"hansukin-prod-emailSender"}}


//////////////////
// WEBPACK FOOTER
// ./src/aws/config.json
// module id = 329
// module chunks = 1